import { capturePostHogEvent } from './posthog'

/** Reserved for waitlist email/cron (HIR-262) — emit from API only, not web SDK yet */
export const WAITLIST_SERVER_EVENTS = {
  confirmationSent: 'waitlist_confirmation_sent',
  nurtureD1: 'waitlist_nurture_d1',
  nurtureD5: 'waitlist_nurture_d5',
  nurtureD12: 'waitlist_nurture_d12',
} as const

export const POSTHOG_EVENTS = {
  waitlistPageView: 'waitlist_page_view',
  waitlistSubmit: 'waitlist_submit',
  signupCompleted: 'signup_completed',
  onboardingStepViewed: 'onboarding_step_viewed',
  onboardingCompleted: 'onboarding_completed',
  resumeImportStarted: 'resume_import_started',
  resumeImportCompleted: 'resume_import_completed',
  resumeCreated: 'resume_created',
  jdTailoringStarted: 'jd_tailoring_started',
  jdTailoringCompleted: 'jd_tailoring_completed',
  resumeExported: 'resume_exported',
  freeLimitHit: 'free_limit_hit',
} as const

export type UtmProps = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
}

export function trackSignupCompleted(method: 'google' | 'email'): void {
  capturePostHogEvent(POSTHOG_EVENTS.signupCompleted, { method })
}

export function trackResumeCreated(resumeId: string): void {
  capturePostHogEvent(POSTHOG_EVENTS.resumeCreated, { resume_id: resumeId })
}

export function trackJdTailoringStarted(resumeId: string): void {
  capturePostHogEvent(POSTHOG_EVENTS.jdTailoringStarted, { resume_id: resumeId })
}

export function trackJdTailoringCompleted(
  resumeId: string,
  outcome: 'completed' | 'failed',
): void {
  capturePostHogEvent(POSTHOG_EVENTS.jdTailoringCompleted, {
    resume_id: resumeId,
    outcome,
  })
}

export function trackResumeExported(format: 'pdf' | 'docx', resumeId: string): void {
  capturePostHogEvent(POSTHOG_EVENTS.resumeExported, {
    format,
    resume_id: resumeId,
  })
}

export function trackResumeImportStarted(source: 'onboarding' | 'ai_memory'): void {
  capturePostHogEvent(POSTHOG_EVENTS.resumeImportStarted, { source })
}

export function trackResumeImportCompleted(
  source: 'onboarding' | 'ai_memory',
  outcome: 'success' | 'error',
): void {
  capturePostHogEvent(POSTHOG_EVENTS.resumeImportCompleted, { source, outcome })
}

export function trackOnboardingStepViewed(step: number): void {
  capturePostHogEvent(POSTHOG_EVENTS.onboardingStepViewed, { step })
}

export function trackOnboardingCompleted(): void {
  capturePostHogEvent(POSTHOG_EVENTS.onboardingCompleted)
}

export function trackWaitlistPageView(utm: UtmProps = {}): void {
  capturePostHogEvent(POSTHOG_EVENTS.waitlistPageView, {
    utm_source: utm.utm_source ?? '',
    utm_medium: utm.utm_medium ?? '',
    utm_campaign: utm.utm_campaign ?? '',
  })
}

export function trackWaitlistSubmit(
  result: 'success' | 'error',
  errorCode?: string,
): void {
  capturePostHogEvent(POSTHOG_EVENTS.waitlistSubmit, {
    result,
    ...(errorCode ? { error_code: errorCode } : {}),
  })
}

export function trackFreeLimitHit(feature: 'export' | 'tailoring'): void {
  capturePostHogEvent(POSTHOG_EVENTS.freeLimitHit, { feature })
}
